import { render, staticRenderFns } from "./my-project.vue?vue&type=template&id=0f9ff687&scoped=true"
import script from "./my-project.vue?vue&type=script&lang=js"
export * from "./my-project.vue?vue&type=script&lang=js"
import style0 from "./my-project.vue?vue&type=style&index=0&id=0f9ff687&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9ff687",
  null
  
)

export default component.exports